import EcoSection from 'eco-design/base/eco-section';
import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import style from './index.module.scss';
import { useLang } from '@/i18n';

interface Props {}

const Screen2: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.Screen2');

    return (
        <div className={`${style.comp} temp-Screen2 Screen2 GtmModuleData-section`} id="Screen2" data-section-id="Screen2">
            <EcoSection
                title={t.rich('title', {
                    s: (v: string) => <span>{v}</span>,
                })}
                desc={t('desc')}
            />
            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1748674025324/screen2.jpg" />
        </div>
    );
};
export default Screen2;
